export default __webpack_public_path__ + "static/media/Dark_File_Reload.559df660.svg";